import defaultConfig, { LEFT, RIGHT } from '../default/config_default';
import { cloneDeep } from 'lodash';

let page = cloneDeep(defaultConfig);

page.imageSrc = 'background/strona_009.jpg';
page.images = [
  {
    imageId: 'page009_zoom0',
    rectangle: {
      x: 605,
      y: 1760,
      width: 1040,
      height: 695,
    },
    imageSrc: 'images/page009/009 3.jpg',
  },
  {
    imageId: 'page009_zoom1',
    rectangle: {
      x: 603,
      y: 1020,
      width: 1182,
      height: 703,
    },
    imageSrc: 'images/page009/009 2.jpg',
  },
  {
    imageId: 'page009_zoom2',
    rectangle: {
      x: 598,
      y: 290,
      width: 1183,
      height: 697,
    },
    imageSrc: 'images/page009/009 1.jpg',
  },
];

page.games = [
  {
    id: 'page009_game3',
    icon: 'ikonaStepbystep',

    pos: {
      x: RIGHT,
      y: 1743,
    },
    item: {
      id: 'page009_game3',
    },
    rectangle: {
      id: 'page009_rect2',
    },
  },
  {
    id: 'page009_game2',
    icon: 'ikonaStepbystep',

    pos: {
      x: RIGHT,
      y: 1030,
    },
    item: {
      id: 'page009_game2',
    },
    rectangle: {
      id: 'page009_rect1',
    },
  },
  {
    id: 'page009_game1',
    icon: 'ikonaStepbystep',

    pos: {
      x: RIGHT,
      y: 273,
    },
    item: {
      id: 'page009_game1',
    },
    rectangle: {
      id: 'page009_rect0',
    },
  },
];
page.rectangle = [
  {
    id: 'page009_rect0',

    tooltip: '',

    linked: ['page009_game1'],
    x: 131,
    y: 273,
    width: 457,
    height: 717,
  },
  {
    id: 'page009_rect1',

    tooltip: '',

    linked: ['page009_game2'],
    x: 131,
    y: 1030,
    width: 456,
    height: 660,
  },
  {
    id: 'page009_rect2',

    tooltip: '',

    linked: ['page009_game3'],
    x: 128,
    y: 1743,
    width: 460,
    height: 207,
  },
];
export default page;
